import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import styles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  field: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  id: null,
  value: false
};

export default class CheckBoxInput extends PureComponent {
  render() {
    const id = this.props.id || `${uniqueId('checkbox-')}_${this.props.field.replace('.', '_')}`;
    const css = `${styles["text-input"]} ${styles["checkbox-input"]} ${this.props.required ? styles.required : ""}`;
    const { field, onChange, value } = this.props;
    return (
      <div className={css}>
        <label
          className="rec-label-checkbox"
          htmlFor={id} >
          <input
            className="rec-input-hide"
            type="checkbox"
            id={id}
            data-field={field}
            checked={value}
            onChange={() => onChange({ target: {value: !value , dataset: { field }}})} />
          <span className="rec-input-checkbox" />
          {this.props.label}
        </label>
      </div>
    );
  }
}

CheckBoxInput.propTypes = propTypes;
CheckBoxInput.defaultProps = defaultProps;
